import React from "react"
import PropTypes from "prop-types"
import i18n from "i18n"
import {
  FormControlLabel,
  Grid,
  Paper,
  Switch,
  Typography,
} from "@mui/material"
import { useMarginsDiscounts } from "hooks/margin/useMarginsDiscounts"
import TextFieldNumber from "common/TextFieldNumber"

const BajasTab = ({ isBudgetClosed = false }) => {
  const { state, setCostReduction, setCostReductionOverwrite } =
    useMarginsDiscounts()

  return (
    <Grid container spacing={2}>
      <Grid container item spacing={2}>
        <Grid item xs={12}>
          <Paper
            variant="outlined"
            sx={{
              p: 2,
              borderRadius: 2,
            }}
          >
            <Typography sx={{ mb: 3, p: 1 }}>
              {i18n.t("bajasTab.panelTitle")}
            </Typography>
            <Grid container item spacing={2}>
              <Grid item xs={6}>
                <TextFieldNumber
                  disabled={isBudgetClosed}
                  label={i18n.t("bajasTab.costReduction")}
                  value={state.bajas.costReduction}
                  onChange={e => setCostReduction(e)}
                  isPercentage
                  decimalScale={4}
                />
              </Grid>

              <Grid
                item
                xs={6}
                // sm={8}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FormControlLabel
                  control={
                    <Switch
                      disabled={isBudgetClosed}
                      checked={state.bajas.costReductionOverwrite}
                      onChange={event =>
                        setCostReductionOverwrite(event.target.checked)
                      }
                      sx={{ marginRight: 1 }}
                    />
                  }
                  label={i18n.t("bajasTab.costReductionOverwrite")}
                  sx={{
                    alignItems: "center",
                    "& .MuiFormControlLabel-label": {
                      verticalAlign: "middle",
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Grid>
  )
}

BajasTab.propTypes = {
  isBudgetClosed: PropTypes.bool,
}

export default BajasTab
